/* Elektronische Widerrufsfunktion (§ 356a BGB) — Verhalten des Formulars aus
   snippets/kindl-widerruf-formular.liquid. Ausgelagert am 30.09.2026 aus
   sections/kindl-vertrag-widerrufen.liquid, weil das Formular im Lesefenster der
   Landing erst nach dem Klonen der <template>-Vorlage existiert (Skripte in
   <template> laufen nicht, getElementById beim Laden fände nichts).
   Aufruf: kindlWiderrufInit(wurzel) — wurzel = Element, das das Formular enthält.
   Liest ?widerruf=ok&nr=… bzw. ?widerruf=fehler&grund=… (hängt das ERP an).
   22.10.2026 Spam-Schutz: Die ERP-Adresse steht nicht mehr im HTML, sondern wird erst
   beim Absenden gesetzt — und nur, wenn ein Mensch Schritt 1 → „Weiter“ → Schritt 2
   durchlaufen hat, die Bot-Falle (website) leer ist und seit dem Laden mind. 4 s
   vergangen sind.
   22.10.2026 Kästchen „Ich bin ein Mensch“ (ALTCHA-Prinzip, ohne fremden Anbieter):
   Beim Ankreuzen holt der Browser eine Rechenaufgabe vom ERP (kindl_widerruf_aufgabe),
   löst sie (SHA-256, meist < 1 s) und schickt Lösung und Signatur in den Feldern
   kw_salt/kw_challenge/kw_zahl/kw_signatur mit. Das ERP prüft sie in
   kindl_online_widerruf. Ist die Aufgabe nicht abrufbar (ERP-Teil noch nicht
   eingerichtet, Netzfehler), wird der Kunde NICHT blockiert: Das Häkchen wird trotzdem
   gesetzt und das ERP entscheidet. Ein echter Widerruf darf nie am Kästchen scheitern.
   22.10.2026 (nachmittags): Frühe Prüfung im Browser. Das Kästchen steht in Schritt 1 und ist
   Pflicht für „Weiter“. Die Bestellnummer muss nach Entfernen von Leerzeichen und führendem „#“
   aus 4–7 Ziffern bestehen — dieselbe Regel wie der Sofort-Stopp im ERP-Skript. Geprüft bei
   „Weiter“ und noch einmal beim Absenden; bei Fehlern gibt es eine Meldung im Formular und
   KEINE Anfrage ans ERP.
   22.10.2026 (Korrektur): Bestellnummer FREIWILLIG, Format nur noch Hinweis. Grund: Ein Widerruf
   ohne zuordenbare Bestellnummer bleibt wirksam (§ 355 BGB); der Händlerbund rät von der
   Bestellnummer als Pflichtfeld ab. Bots hält das Kästchen ab (im ERP scharf geprüft), nicht
   mehr die Formatregel. Ungewöhnliches Format → einmaliger Hinweis bei „Weiter“, beim zweiten
   Klick geht es weiter. Beim Absenden wird das Format nicht mehr geprüft. */
(function () {
  if (window.kindlWiderrufInit) return;
  var GRUENDE = { felder: 'Bitte füllen Sie Name und E-Mail-Adresse aus.', email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.', bestaetigung: 'Bitte bestätigen Sie den Widerruf.', pruefung: 'Die Sicherheitsprüfung „Ich bin ein Mensch“ ist abgelaufen oder fehlgeschlagen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.', zuviele: 'Zu viele Versuche in kurzer Zeit. Bitte versuchen Sie es später erneut oder senden Sie Ihren Widerruf per E-Mail an info@muenchnerkindlbrauerei.de.' };
  var ERP = ['https://erp.', 'muenchnerkindlbrauerei.de', '/api/method/'].join('');
  var ZIEL = ERP + 'kindl_online_' + 'widerruf';
  var AUFGABE = ERP + 'kindl_widerruf_aufgabe';
  var MIN_MS = 4000;
  var NR_TEXT = 'Hinweis: Das sieht nicht wie eine Bestellnummer aus (z. B. #1001). Bitte prüfen Sie die Eingabe – oder klicken Sie noch einmal auf „Weiter“, um den Widerruf trotzdem so abzugeben.';
  var MENSCH_TEXT = 'Bitte bestätigen Sie zuerst „Ich bin ein Mensch“.';
  function nummerOk(v) { return /^[0-9]{4,7}$/.test(String(v || '').replace(/ /g, '').replace(/^#+/, '')); }
  var RING = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="9" opacity=".25"/><path class="kw-ring" d="M21 12a9 9 0 0 0-9-9"/></svg>';
  var HAKEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function hex(buf) { return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  function sha(s) { return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(hex); }
  function loesen(a) {
    var max = Math.min(parseInt(a.maxnumber, 10) || 100000, 1000000), n = 0;
    return new Promise(function (fertig, fehler) {
      (function runde() {
        var bis = Math.min(n + 2000, max + 1), kette = Promise.resolve();
        for (; n < bis; n++) { (function (k) { kette = kette.then(function (g) { return g !== undefined ? g : sha(a.salt + k).then(function (h) { return h === a.challenge ? k : undefined; }); }); })(n); }
        kette.then(function (g) { if (g !== undefined) fertig(g); else if (n > max) fehler(new Error('keine Lösung')); else setTimeout(runde, 0); }, fehler);
      })();
    });
  }

  window.kindlWiderrufInit = function (wurzel) {
    if (!wurzel) return;
    var el = function (id) { return wurzel.querySelector('#' + id); };
    var form = el('kw-form');
    if (!form || form.getAttribute('data-kw-bereit')) return;
    form.setAttribute('data-kw-bereit', '1');
    var geladen = Date.now(), geprueft = false, mensch = false, laeuft = false;

    var q = new URLSearchParams(location.search);
    if (q.get('widerruf') === 'ok') {
      el('kw-ok').hidden = false;
      if (q.get('nr')) el('kw-nr').textContent = 'Vorgangsnummer: ' + q.get('nr');
      form.style.display = 'none';
    } else if (q.get('widerruf') === 'fehler') {
      el('kw-fehler').hidden = false;
      if (GRUENDE[q.get('grund')]) el('kw-grund').textContent = GRUENDE[q.get('grund')];
    }
    var s1 = el('kw-schritt1'), s2 = el('kw-schritt2'), senden = el('kw-senden');
    var kasten = el('kw-mensch'), box = el('kw-mensch-box'), haken = el('kw-mensch-haken'), text = el('kw-mensch-text');
    if (senden && kasten) senden.disabled = true;

    var hinweis = el('kw-hinweis'), nrFeld = el('kw-bestellung');
    function melde(t) { if (hinweis) { hinweis.textContent = t; hinweis.hidden = !t; } }
    var gewarnt = '';
    if (nrFeld) nrFeld.addEventListener('input', function () { gewarnt = ''; melde(''); });
    // Nur ein Hinweis, keine Sperre: leer ist in Ordnung; ungewöhnliches Format → einmal
    // nachfragen, bei unveränderter Eingabe und erneutem „Weiter“ geht es weiter.
    function nummerPruefen() {
      var v = String(nrFeld.value || '').trim();
      if (!v || nummerOk(v) || gewarnt === v) return true;
      gewarnt = v; melde(NR_TEXT); nrFeld.focus();
      return false;
    }
    function setze(name, wert) { var f = form.querySelector('input[name="' + name + '"]'); if (f) f.value = wert; }
    function fertig() {
      mensch = true; laeuft = false;
      kasten.className = 'kw-mensch ist-fertig'; box.innerHTML = HAKEN; text.textContent = 'Geprüft';
      haken.disabled = true; senden.disabled = false;
      kasten.classList.remove('ist-hinweis'); if (hinweis && hinweis.textContent === MENSCH_TEXT) melde('');
    }
    if (haken) haken.addEventListener('change', function () {
      if (!haken.checked || laeuft || mensch) return;
      laeuft = true; haken.disabled = true;
      kasten.className = 'kw-mensch ist-aktiv'; box.innerHTML = RING; text.textContent = 'Wird geprüft …';
      fetch(AUFGABE, { method: 'GET', credentials: 'omit', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var a = j && j.message; if (!a || !a.salt || !a.challenge) throw new Error('keine Aufgabe');
          return loesen(a).then(function (zahl) { setze('kw_salt', a.salt); setze('kw_challenge', a.challenge); setze('kw_zahl', String(zahl)); setze('kw_signatur', a.signature || ''); });
        })
        .then(fertig, fertig);
    });

    el('kw-weiter').addEventListener('click', function () {
      var felder = ['kw-name', 'kw-bestellung', 'kw-email'].map(el);
      for (var i = 0; i < felder.length; i++) { if (!felder[i].reportValidity()) return; }
      if (!nummerPruefen()) return;
      if (kasten && !mensch) { kasten.classList.add('ist-hinweis'); melde(laeuft ? 'Die Prüfung „Ich bin ein Mensch“ läuft noch – einen Moment bitte.' : MENSCH_TEXT); haken.focus(); return; }
      melde('');
      var teil = wurzel.querySelector('input[name="umfang"]:checked').value === 'teil';
      var zeilen = [['Name', felder[0].value], ['Bestellnummer', felder[1].value || '– (nicht angegeben)'], ['E-Mail', felder[2].value],
        ['Bestellt/erhalten', el('kw-datum').value || '–'],
        ['Betrifft', teil ? ('einzelne Artikel: ' + (el('kw-waren').value || '–')) : 'den gesamten Vertrag']];
      var dl = el('kw-zusammenfassung'); dl.textContent = '';
      zeilen.forEach(function (z) { var dt = document.createElement('dt'); dt.style.fontWeight = '600'; dt.textContent = z[0]; var dd = document.createElement('dd'); dd.style.margin = '0'; dd.textContent = z[1]; dl.appendChild(dt); dl.appendChild(dd); });
      geprueft = true;
      s1.style.display = 'none'; s2.style.display = 'flex'; s2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    el('kw-zurueck').addEventListener('click', function () { s2.style.display = 'none'; s1.style.display = 'flex'; });

    form.addEventListener('submit', function (e) {
      var falle = el('kw-website');
      if (!geprueft || (kasten && !mensch) || (falle && falle.value) || Date.now() - geladen < MIN_MS) {
        e.preventDefault();
        if (!geprueft || (kasten && !mensch)) { s2.style.display = 'none'; s1.style.display = 'flex'; }
        if (kasten && !mensch) { kasten.classList.add('ist-hinweis'); melde(MENSCH_TEXT); haken.focus(); }
        return;
      }
      form.action = ZIEL;
    });
  };
})();
